import { ProcessorSwitch } from '../../atoms/processor-switch';
import { PaymentMethodsButtonsJustifi } from './payment-methods-buttons-justifi';
import { PaymentMethodsButtonsStripe } from './payment-methods-buttons-stripe';

export const PaymentMethodsButtons = () => {
  return <ProcessorSwitch stripeContent={PaymentMethodsButtonsStripe} justifiContent={PaymentMethodsButtonsJustifi} />;
};
